import { Button, IconButton, SliderModal, Text, HStack, VStack } from '@genial/components';
import { Color, Spacing, Typography } from '@genial/design-tokens';
import { RouteProp, useNavigation, useRoute } from '@react-navigation/native';
import { Flex, ScrollView } from 'native-base';
import React, { useCallback, useEffect, useState } from 'react';
import { Dimensions } from 'react-native';
import { useRecoilState } from 'recoil';

import {
  SignedInNavigationScreenNavigationProp,
  SignedInRootStackParamList,
} from '../../../../../routes/types';
import { financialSummuryOrdenationState } from '../../../../../store/home/financialSummuryOrdenation/atom';

import { SelectableButton } from './components/SelectableButton';

export const FinancialSummaryFilter = () => {
  const [ordenationState, setOrdenationState] = useRecoilState(financialSummuryOrdenationState);
  const { height } = Dimensions.get('window');
  const { params } = useRoute<RouteProp<SignedInRootStackParamList, 'FinancialFilter'>>();
  const navigation = useNavigation<SignedInNavigationScreenNavigationProp>();

  const [ordenationSelected, setOrdenationSelected] = useState({
    selectedOrderType: null,
    selectedDisplayOrder: null,
  });

  const goBack = useCallback(() => {
    if (navigation.canGoBack()) {
      navigation.goBack();
    }
  }, [navigation]);

  const applyFilter = () => {
    setOrdenationState({
      selectedOrderType: ordenationSelected.selectedOrderType,
      selectedDisplayOrder: ordenationSelected.selectedDisplayOrder,
      hasOrdernation: true,
    });

    navigation.navigate('HomeFinancialSummary');
  };

  useEffect(() => {
    if (ordenationState.selectedOrderType) {
      setOrdenationSelected((prev) => ({
        ...prev,
        selectedOrderType: ordenationState.selectedOrderType,
      }));
    }
    if (ordenationState.selectedDisplayOrder) {
      setOrdenationSelected((prev) => ({
        ...prev,
        selectedDisplayOrder: ordenationState.selectedDisplayOrder,
      }));
    }
  }, []);

  return (
    <SliderModal dismissWhenClickOutside onDismiss={goBack} width={0.23} direction={'bottom'}>
      <VStack maxHeight={{ base: height * 0.8 }} flex={1}>
        <VStack
          alignItems={'center'}
          w={'full'}
          p={Spacing['inline.xxs']}
          borderTopRadius={{ base: Spacing['inline.xxxs'], sm: Spacing['inline.xxxs'] }}
          backgroundColor={Color['neutral.white']}
          space={Spacing['inline.xxxs']}>
          <HStack
            w={'full'}
            space={Spacing['stack.quarck']}
            alignItems="center"
            justifyContent={'space-between'}>
            <Text variant="semibold" fontSize={Typography['fontsize.lg']} lineHeight="distant">
              Escolha o tipo de ordenação
            </Text>
            <IconButton
              icon="Close"
              testId={'button-close'}
              iconColor={Color['neutral.dark']}
              iconSize="xxs"
              onPress={goBack}
            />
          </HStack>
        </VStack>
        <ScrollView showsVerticalScrollIndicator={false} backgroundColor={Color['neutral.white']}>
          <VStack
            px={Spacing['inline.xxs']}
            pb={Spacing['inline.xxs']}
            maxWidth={{ base: '366px', lg: 'full' }}
            space={Spacing['stack.xxxs']}>
            <Text variant="semibold" fontSize={Typography['fontsize.md']}>
              Ordenar por
            </Text>
            <Flex style={{ gap: 8 }} direction="row" flexWrap="wrap">
              {params?.ordernationTypes.map((type) => (
                <SelectableButton
                  key={type.label}
                  label={type.label}
                  isSelected={ordenationSelected.selectedOrderType === type.key}
                  onPress={() =>
                    setOrdenationSelected((prev) => ({ ...prev, selectedOrderType: type.key }))
                  }
                />
              ))}
            </Flex>
            <Text variant="semibold" fontSize={Typography['fontsize.md']}>
              Ordem de exibição
            </Text>
            <Flex style={{ gap: 8 }} direction="row" flexWrap="wrap">
              <SelectableButton
                label="CRESCENTE"
                isSelected={ordenationSelected.selectedDisplayOrder === 'asc'}
                onPress={() =>
                  setOrdenationSelected((prev) => ({ ...prev, selectedDisplayOrder: 'asc' }))
                }
              />
              <SelectableButton
                label="DECRESCENTE"
                isSelected={ordenationSelected.selectedDisplayOrder === 'desc'}
                onPress={() =>
                  setOrdenationSelected((prev) => ({ ...prev, selectedDisplayOrder: 'desc' }))
                }
              />
            </Flex>
          </VStack>
          <VStack
            justifyContent={'space-between'}
            p={Spacing['inline.xxs']}
            space={Spacing['inline.nano']}
            borderTopWidth={1}
            borderTopColor={Color['neutral.lightest']}>
            <Button
              onPress={applyFilter}
              isDisabled={
                !ordenationSelected.selectedOrderType || !ordenationSelected.selectedDisplayOrder
              }>
              CONFIRMAR
            </Button>
          </VStack>
        </ScrollView>
      </VStack>
    </SliderModal>
  );
};
